import React, { ReactNode } from 'react'
import { Container, CssBaseline } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles'

export const defaultTheme = {
  palette: {
    primary: {
      main: '#0092DA',
      light: '#03AADF',
      dark: '#0063F8',
    },
  },
  typography: {
    fontFamily: ['Lato', 'sans-serif'].join(','),
    h1: {
      fontSize: '1.5rem',
      fontWeight: '600',
      lineHeight: 1.33,
      color: 'rgba(0, 0, 0, 0.9)',
      marginBottom: '0.25rem',
    },
  },
  breakpoints: {
    values: {
      xs: 320, // min-width of widget
      sm: 420, // decrease spacing below 400px
      md: 520, // max-width of widget
      lg: 1200, // default value
      xl: 1536, // default value
    },
  },
}

export interface WidgetContainerProps {
  theme?: object
  sx?: object
  children: ReactNode
}

const WidgetContainer = (props: WidgetContainerProps) => {
  const theme = createTheme(props?.theme || defaultTheme)
  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth='md'
        sx={theme => ({
          minWidth: theme.breakpoints.values.xs,
          py: theme.spacing(4),
          height: theme.spacing(112.5),
          ...props.sx,
        })}
      >
        <CssBaseline />
        {props.children}
      </Container>
    </ThemeProvider>
  )
}

export default WidgetContainer
